import React from "react";
import PolicyLayout from "../../../components/PolicyLayout";
import s from "../../../styles/PolicyLayout.module.css";

export default function SmartGpsPrivacy() {
  return (
    <PolicyLayout
      title="privacy policy"
      appName="Smart GPS Compass"
      date="NOVEMBER 2025"
    >
      {/* Intro */}
      <p>
        This Privacy Policy explains how Smart GPS Compass (“we”, “our”, “us”,
        or “the Application”) collects, uses, and protects information when you
        use our mobile application. By downloading or using the Application, you
        consent to the practices described below.
      </p>

      {/* 1. Information We Collect */}
      <div className={s.title}>1) Information We Collect</div>

      <p><strong>Location and Sensor Data.</strong></p>
      <ul>
        <li>GPS coordinates (latitude, longitude) to display your current location.</li>
        <li>Compass orientation (0–360°) using device sensors (magnetometer + accelerometer).</li>
        <li>Signal accuracy in meters or feet.</li>
        <li>This data is processed locally and not stored on our servers.</li>
      </ul>

      <p><strong>Automatically Collected Data.</strong></p>
      <ul>
        <li>Device information (model, OS version, language).</li>
        <li>Usage data (app launches, feature interactions, session duration).</li>
        <li>Crash logs and diagnostics (via Firebase Crashlytics).</li>
      </ul>

      <p><strong>Payment Data.</strong></p>
      <ul>
        <li>Subscription purchases (PRO access) are processed via Apple App Store and Google Play.</li>
        <li>We do not collect or store payment card details.</li>
      </ul>

      <p><strong>Third-Party Services.</strong></p>
      <ul>
        <li>Firebase Analytics & Crashlytics – analytics, diagnostics, stability.</li>
        <li>RevenueCat – subscription and purchase management.</li>
      </ul>

      <p>
        These third-party tools may collect limited technical and usage data
        under their respective privacy policies.
      </p>

      {/* 2. How We Use Information */}
      <div className={s.title}>2) How We Use Information</div>

      <p>We use collected information to:</p>
      <ul>
        <li>Provide compass and GPS functionality.</li>
        <li>Ensure accuracy and performance.</li>
        <li>Improve user experience and add new features.</li>
        <li>Manage subscriptions and verify purchases.</li>
        <li>Monitor stability and fix technical issues.</li>
        <li>Comply with legal obligations.</li>
      </ul>

      {/* 3. Legal Basis for Processing */}
      <div className={s.title}>3) Legal Basis for Processing (GDPR)</div>

      <ul>
        <li><strong>Performance of a contract:</strong> to provide compass/GPS services.</li>
        <li><strong>Consent:</strong> for optional analytics or tracking.</li>
        <li><strong>Legitimate interest:</strong> to improve functionality and prevent abuse.</li>
        <li><strong>Legal obligation:</strong> to comply with applicable laws.</li>
      </ul>

      {/* 4. Data Retention */}
      <div className={s.title}>4) Data Retention</div>

      <ul>
        <li>Location and compass data are processed in real time and not stored on servers.</li>
        <li>Analytics and diagnostics are retained only as needed for improvements.</li>
        <li>Subscription data is managed by App Store and Google Play.</li>
      </ul>

      {/* 5. Sharing and Disclosure */}
      <div className={s.title}>5) Sharing and Disclosure</div>

      <p>We do not sell or rent your personal information. Data may be shared only:</p>
      <ul>
        <li>With trusted third-party providers (Firebase, RevenueCat) under confidentiality.</li>
        <li>When required by law, regulation, or court order.</li>
        <li>In a merger, acquisition, or asset transfer with proper safeguards.</li>
      </ul>

      {/* 6. International Data Transfers */}
      <div className={s.title}>6) International Data Transfers</div>
      <p>
        Your information may be processed outside your country of residence. We
        ensure GDPR-compliant safeguards such as Standard Contractual Clauses.
      </p>

      {/* 7. User Rights */}
      <div className={s.title}>7) User Rights</div>

      <p><strong>Under GDPR (EEA users):</strong></p>
      <ul>
        <li>Right to access, correct, or delete data.</li>
        <li>Right to restrict or object to processing.</li>
        <li>Right to withdraw consent.</li>
        <li>Right to data portability.</li>
        <li>Right to lodge a complaint with a Data Protection Authority.</li>
      </ul>

      <p><strong>Under CCPA (California users):</strong></p>
      <ul>
        <li>Right to know what personal information is collected.</li>
        <li>Right to request deletion.</li>
        <li>Right to opt out of data sale (we do not sell).</li>
        <li>Right to equal service when exercising rights.</li>
      </ul>

      <p>Users can contact us to exercise these rights.</p>

      {/* 8. Children’s Privacy */}
      <div className={s.title}>8) Children’s Privacy</div>
      <p>
        The Application is not directed to children under 13 (or 16 where
        required). We do not knowingly collect personal information from
        children.
      </p>

      {/* 9. Data Security */}
      <div className={s.title}>9) Data Security</div>
      <p>
        We implement technical and organizational measures, including secure
        communication protocols, to protect user data. However, no system is
        100% secure, and absolute protection cannot be guaranteed.
      </p>

      {/* 10. Changes */}
      <div className={s.title}>10) Changes to This Privacy Policy</div>
      <p>
        We may update this Privacy Policy periodically. Changes will be
        published within the Application or on the store listing. Continued use
        of the Application after updates constitutes acceptance of the revised
        Policy.
      </p>

      {/* 11. Contact Us */}
      <div className={s.title}>11) Contact Us</div>
      <p>For privacy-related questions or requests, contact:</p>
      <p>Developer: Aleksandra Rakitina</p>
      <p>Email: alexwadek@gmail.com</p>
    </PolicyLayout>
  );
}
